var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFinanceImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 82,
    viewBox: "0 0 111 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4550_643674)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.0441 5.99493C11.833 8.94838 2.12037 16.1316 0.396766 29.5768C-1.05578 40.9019 0.44194 60.9643 20.868 64.5295C60.615 71.4701 91.6781 74.7646 103.92 55.4617C115.159 37.7481 114.304 11.2654 92.0395 6.40982C76.2942 2.97468 50.2109 -0.333892 24.0441 5.99493Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M55.4997 81.9297C82.52 81.9297 104.424 79.5385 104.424 76.5889C104.424 73.6392 82.52 71.248 55.4997 71.248C28.4795 71.248 6.5752 73.6392 6.5752 76.5889C6.5752 79.5385 28.4795 81.9297 55.4997 81.9297Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M18.9468 63.4573C18.9468 63.4573 15.9479 62.6416 15.2842 59.8217C15.2842 59.8217 19.9233 58.8513 20.0762 63.6893L18.9468 63.4573Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M19.3112 63.1509C19.3112 63.1509 17.2053 59.8107 19.0332 56.6709C19.0332 56.6709 22.5742 58.9247 21.0244 63.1509H19.3112Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8535 63.1509C19.8535 63.1509 20.9447 59.6102 24.2841 58.9316C24.2841 58.9316 24.9201 61.2241 22.1366 63.1509H19.8535Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6777 63.084L18.3032 67.2856H22.1292L22.6748 63.084H17.6777Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M18.9468 63.4573C18.9468 63.4573 15.9479 62.6416 15.2842 59.8217C15.2842 59.8217 19.9233 58.8513 20.0762 63.6893L18.9468 63.4573Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M19.3112 63.1509C19.3112 63.1509 17.2053 59.8107 19.0332 56.6709C19.0332 56.6709 22.5742 58.9247 21.0244 63.1509H19.3112Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8535 63.1509C19.8535 63.1509 20.9447 59.6102 24.2841 58.9316C24.2841 58.9316 24.9201 61.2241 22.1366 63.1509H19.8535Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6777 63.084L18.3032 67.2856H22.1292L22.6748 63.084H17.6777Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 75.5908H29.6943V71.4068H12.4444V75.5908Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M16.212 71.498H33.4619V67.314H16.212V71.498Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3236 0.0742188H24.9404V75.5947H87.3236V0.0742188Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M65.0323 3.02344H53.3633V4.74628H65.0323V3.02344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1372 5.99495C50.1869 5.99495 51.038 5.13388 51.038 4.0717C51.038 3.00951 50.1869 2.14844 49.1372 2.14844C48.0874 2.14844 47.2363 3.00951 47.2363 4.0717C47.2363 5.13388 48.0874 5.99495 49.1372 5.99495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M81.5865 8.99023H30.6777V68.221H81.5865V8.99023Z",
    fill: "#184FA6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.875 50.4619H35.8555V62.9191H42.875V50.4619Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3181 45.9053H47.2986V62.9193H54.3181V45.9053Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7617 38.6055H58.7422V62.9187H65.7617V38.6055Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.201 31.9639H70.1815V62.9188H77.201V31.9639Z",
    fill: "#2E2E2E"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M56.1329 74.1808C57.3669 74.1808 58.3673 73.1686 58.3673 71.92C58.3673 70.6714 57.3669 69.6592 56.1329 69.6592C54.8988 69.6592 53.8984 70.6714 53.8984 71.92C53.8984 73.1686 54.8988 74.1808 56.1329 74.1808Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M67.3145 50.5283C67.3145 50.5283 58.4776 52.5324 55.0061 58.7488C51.5346 64.9651 65.7786 75.6924 65.7786 75.6924L75.6302 75.7276L77.9029 65.3096L72.7668 57.8979L67.3145 50.5283Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.336 49.4382C85.336 49.4382 96.8799 48.2006 96.456 54.3817C96.032 60.5629 89.5477 73.7198 89.5477 73.7198H75.3558C75.3558 73.7198 64.5833 57.0188 69.8305 51.6463C75.0778 46.2738 76.2593 50.8833 85.336 49.4382Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5589 75.7279L80.927 78.0837L73.2715 74.1493L72.1074 72.0537H79.8254H92.106L89.5589 75.7279Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9037 56.1183C89.823 52.4582 91.8663 48.4605 95.7305 51.3893C98.3784 53.3969 101.523 59.7961 101.683 65.7206C102.058 79.3346 85.5522 64.6869 83.502 56.8883L85.5348 55.6753C85.5348 55.6753 88.9542 62.2081 92.6864 63.6215C95.376 64.6482 92.5022 61.5295 90.9037 56.1183Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M90.9037 56.1183C89.823 52.4582 91.8663 48.4605 95.7305 51.3893C98.3784 53.3969 101.523 59.7961 101.683 65.7206C102.058 79.3346 85.5522 64.6869 83.502 56.8883L85.5348 55.6753C85.5348 55.6753 88.9542 62.2081 92.6864 63.6215C95.376 64.6482 92.5022 61.5295 90.9037 56.1183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9295 49.5161C84.8492 50.0366 84.7981 50.5613 84.7766 51.0877C84.7523 51.812 84.523 52.8844 83.3866 53.0954C81.6491 53.4223 81.1835 50.6341 81.1835 50.6341C81.1835 50.6341 80.0889 48.0253 81.9723 47.6702C83.6785 47.3537 85.277 47.1217 84.9295 49.5161Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M78.2261 53.4397C78.2261 53.4397 79.3068 55.7321 76.5789 60.4295C75.0187 63.1193 79.8246 67.6057 79.8246 67.6057L91.7856 68.8187L89.5546 73.7165H75.3558C75.3558 73.7165 69.1251 63.4639 68.6455 58.1863C68.166 52.9088 78.2261 53.4397 78.2261 53.4397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3055 50.7533C81.3055 50.7533 81.2047 49.906 80.4749 49.9446C79.7452 49.9833 80.0336 51.5479 81.3055 50.7533Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5094 50.2825C84.5094 50.2825 84.2557 49.4703 84.9333 49.1996C85.611 48.9288 85.9967 50.4934 84.5094 50.2825Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9951 71.3084L89.9958 62.0859H74.6885L76.214 71.7796L75.9951 73.0243L89.1584 73.1297L88.9951 71.3084Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.834 75.7275C82.834 75.7275 79.9289 76.7542 80.9262 78.0833C81.9236 79.4123 83.5012 77.2043 83.5012 77.2043L82.834 75.7275Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M74.6885 62.0957L77.7395 66.1391C79.5111 68.505 81.9034 70.3201 84.6443 71.378L89.1618 73.136L77.0237 73.0375H75.9985L76.2175 71.7929L74.6885 62.0957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9684 49.4106C85.123 49.4744 85.2905 49.4998 85.4568 49.4845C85.6231 49.4692 85.7833 49.4137 85.924 49.3227C86.0594 49.1744 86.1339 48.9796 86.1325 48.7777C86.2298 47.8038 86.0283 46.4079 85.4132 45.6133C84.7981 44.8187 83.4185 44.882 82.5428 45.0156C82.091 45.0662 81.6525 45.2022 81.2501 45.4164C80.7914 45.7164 80.4291 46.1453 80.2076 46.6505C79.6516 47.8389 79.5717 49.7446 81.0451 50.1665C83.1822 50.7748 84.2908 48.4085 84.2908 48.4085C84.4264 48.7376 84.6078 49.0454 84.8294 49.3227C84.8708 49.3593 84.9177 49.389 84.9684 49.4106Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7441 75.2141C82.7441 75.2141 94.4862 69.149 95.487 72.3732C96.4878 75.5974 88.3945 77.4749 83.1716 77.6683L82.7441 75.2141Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1919 68.3796C82.9154 68.3796 83.502 67.7861 83.502 67.0541C83.502 66.322 82.9154 65.7285 82.1919 65.7285C81.4684 65.7285 80.8818 66.322 80.8818 67.0541C80.8818 67.7861 81.4684 68.3796 82.1919 68.3796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8913 75.6886C79.8913 75.6886 70.5296 66.3008 68.6079 69.0679C66.6863 71.835 73.8204 76.1 78.748 77.8966L79.8913 75.6886Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5265 76.3955C79.5265 76.3955 82.3064 78.8954 80.694 79.6338C79.0816 80.3721 78.748 77.8968 78.748 77.8968L79.5265 76.3955Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2269 53.4397C78.331 52.3848 78.0186 51.3311 77.3579 50.5084C76.6971 49.6857 75.7416 49.1608 74.6998 49.0482C72.5835 48.8196 69.8001 48.9603 67.3259 50.5284C62.5269 53.5733 57.2171 56.0028 58.5272 61.5194C59.8372 67.0361 69.3622 69.3531 69.3622 69.3531L70.6306 67.2435C70.6306 67.2435 62.235 64.3745 63.764 59.888C65.1401 55.8552 77.3234 62.6129 78.2269 53.4397Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M78.2269 53.4397C78.331 52.3848 78.0186 51.3311 77.3579 50.5084C76.6971 49.6857 75.7416 49.1608 74.6998 49.0482C72.5835 48.8196 69.8001 48.9603 67.3259 50.5284C62.5269 53.5733 57.2171 56.0028 58.5272 61.5194C59.8372 67.0361 69.3622 69.3531 69.3622 69.3531L70.6306 67.2435C70.6306 67.2435 62.235 64.3745 63.764 59.888C65.1401 55.8552 77.3234 62.6129 78.2269 53.4397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4215 67.6055C70.4215 67.6055 73.0695 69.4197 72.1069 69.919C71.1443 70.4183 69.5215 69.0892 69.5215 69.0892L70.4215 67.6055Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8319 50.9788C83.7833 50.7191 83.6634 50.4786 83.4859 50.2847C83.3084 50.0908 83.0805 49.9514 82.8284 49.8826C82.5762 49.8137 82.3099 49.8181 82.0601 49.8953C81.8103 49.9725 81.5871 50.1194 81.416 50.319C81.2449 50.5187 81.1328 50.7631 81.0927 51.0243C81.0525 51.2854 81.0859 51.5527 81.189 51.7955C81.2921 52.0383 81.4607 52.2468 81.6756 52.3972C81.8904 52.5475 82.1428 52.6335 82.4037 52.6454L83.0083 55.8485L83.6338 55.7289L83.0292 52.5258C83.3158 52.3973 83.5511 52.1746 83.6968 51.8937C83.8425 51.6129 83.8901 51.2905 83.8319 50.9788ZM82.6087 52.0336C82.4575 52.0628 82.3011 52.046 82.1593 51.9853C82.0175 51.9246 81.8967 51.8227 81.8122 51.6925C81.7276 51.5623 81.6831 51.4097 81.6843 51.2539C81.6855 51.0982 81.7323 50.9462 81.8188 50.8174C81.9053 50.6885 82.0276 50.5885 82.1703 50.53C82.313 50.4715 82.4697 50.4572 82.6204 50.4888C82.7712 50.5203 82.9093 50.5964 83.0173 50.7074C83.1254 50.8185 83.1984 50.9594 83.2273 51.1124C83.2599 51.3153 83.2132 51.523 83.0971 51.6917C82.981 51.8603 82.8046 51.9767 82.6052 52.016L82.6087 52.0336Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1767 55.8973C85.1767 55.8973 84.228 53.5415 82.9283 53.7349C81.6287 53.9283 83.6477 56.822 83.6477 56.822L85.1767 55.8973Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M52.3486 34.748H42.3857V36.4463H52.3486V34.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M52.3486 39.2207H42.3857V40.9189H52.3486V39.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2826 34.748H36.3428V36.4463H39.2826V34.748Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2826 39.2207H36.3428V40.9189H39.2826V39.2207Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8057 21.3982C64.8102 23.6518 63.9591 25.8211 62.4281 27.4579C60.8972 29.0947 58.8034 30.0741 56.5792 30.1937C54.3551 30.3133 52.1705 29.564 50.4767 28.1005C48.7829 26.6371 47.7093 24.5713 47.4778 22.3299C47.2462 20.0886 47.8743 17.8428 49.2323 16.0566C50.5904 14.2703 52.5746 13.0801 54.7751 12.7317C56.9756 12.3833 59.2243 12.9033 61.0568 14.1844C62.8892 15.4655 64.1653 17.4098 64.6215 19.6156C64.6667 19.8547 64.7049 20.0938 64.7396 20.3188C64.7831 20.6769 64.8052 21.0374 64.8057 21.3982Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1328 12.6253V21.4154L64.6257 19.6292C64.6257 19.6292 63.4407 12.5691 56.1328 12.6253Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M64.8061 21.3984C64.7993 22.983 64.3692 24.5363 63.5614 25.8939C62.7536 27.2514 61.5982 28.3628 60.2173 29.1104C58.8364 29.858 57.2815 30.214 55.717 30.1407C54.1526 30.0674 52.6368 29.5676 51.3301 28.6942L56.1499 21.3984L64.6393 19.6123C64.6845 19.8514 64.7227 20.0905 64.7575 20.3155C64.7953 20.6752 64.8115 21.0368 64.8061 21.3984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M43.622 13.2266H24.9404V29.576H43.622V13.2266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4985 14.1514C32.7904 14.1514 32.8808 14.2533 32.8808 14.5487V15.178C34.0484 15.3433 34.719 15.934 35.216 16.9607C35.3689 17.2701 35.3063 17.4388 34.9623 17.59L34.3403 17.8748C34.0484 18.0155 33.9094 17.9522 33.7426 17.6428C33.6128 17.3236 33.3849 17.0551 33.0926 16.8772C32.8004 16.6993 32.4592 16.6213 32.1197 16.6548C31.039 16.6548 30.5456 16.9747 30.5456 17.7096C30.5692 17.934 30.6697 18.143 30.8296 18.3003C30.9896 18.4576 31.1989 18.5534 31.4213 18.571C31.7224 18.6387 32.0277 18.6857 32.3352 18.7116C32.9118 18.7469 33.4805 18.8653 34.024 19.0632C34.2956 19.1534 34.5488 19.2928 34.7712 19.4746C34.9962 19.7143 35.1717 19.9969 35.2875 20.306C35.4032 20.6151 35.4569 20.9445 35.4453 21.2748C35.4453 22.6812 34.5175 23.6235 32.8808 23.8661V24.5342C32.8808 24.8295 32.7904 24.935 32.4985 24.935H31.8035C31.5116 24.935 31.4108 24.8295 31.4108 24.5342V23.8802C30.8424 23.8411 30.2981 23.6326 29.8466 23.281C29.3952 22.9293 29.0567 22.4502 28.8741 21.9042C28.8462 21.8468 28.8318 21.7837 28.832 21.7198C28.8322 21.6558 28.8471 21.5928 28.8753 21.5356C28.9036 21.4784 28.9445 21.4286 28.9949 21.3901C29.0454 21.3516 29.1039 21.3254 29.166 21.3135L29.788 21.0814C30.1042 20.9654 30.2432 21.0428 30.3822 21.3627C30.6649 22.0823 31.2359 22.4421 32.0954 22.4421C33.263 22.4421 33.8329 22.0694 33.8329 21.3135C33.8431 21.1379 33.7949 20.9639 33.696 20.8193C33.5972 20.6747 33.4533 20.5677 33.2873 20.5153C32.8878 20.3664 32.4685 20.2787 32.0433 20.2552C31.4604 20.218 30.8864 20.0924 30.3405 19.8825C30.0719 19.7861 29.8225 19.642 29.6038 19.457C29.3736 19.229 29.1929 18.9548 29.0732 18.6521C28.9535 18.3495 28.8975 18.0248 28.9088 17.699C28.9088 16.3137 29.7741 15.389 31.3969 15.171V14.5487C31.3969 14.2533 31.4977 14.1514 31.7896 14.1514H32.4985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M77.2046 13.877H68.3955V15.5717H77.2046V13.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M77.2046 17.583H68.3955V19.2777H77.2046V17.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M77.2046 21.2891H68.3955V22.9838H77.2046V21.2891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M77.2051 24.9951H72.1455V26.6898H77.2051V24.9951Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4550_643674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 82,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFinanceImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/finance-img.3ca032ba010c5650a83fc343818c8dfa.svg";